module.exports = __webpack_public_path__ + "images/tips/webinars-1@1x.7e1a1e13b5deffa70d0e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/webinars-1@1x.png
// module id = fLgy
// module chunks = 1